module.exports = __webpack_public_path__ + "img/ape-constructor-analyze.dc274c58.svg";